import { FC, SVGAttributes } from 'react';

const ExpandLess: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.29289 15.2071C6.68342 15.5976 7.31658 15.5976 7.70711 15.2071L12 10.9142L16.2929 15.2071C16.6834 15.5976 17.3166 15.5976 17.7071 15.2071C18.0976 14.8166 18.0976 14.1834 17.7071 13.7929L13.0607 9.14645C12.4749 8.56066 11.5251 8.56066 10.9393 9.14645L6.29289 13.7929C5.90237 14.1834 5.90237 14.8166 6.29289 15.2071Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ExpandLess;
